<template>
  <!-- Site wrapper -->
  <div class="wrapper">
    <cabecalho tituloPagina="Planos" />
    <menuLateral />
    <Aviso ref="aviso_modal" />
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div class="container-fluid">
          <p>Seja bem-vindo ao nosso painel de Planos. Escolha a opção que melhor atenda ao seu momento. Não se preocupe,
            você pode começar e adicionar serviços e acesso a qualquer momento. O MIRT oferece flexibilidade para que você tenha
            o máximo de possibilidades e se destaque no mercado.
          </p>
          <spinnerProcessando
          cssClass="ml-2"
          :status="flagsDeControle.carregandoDados.status"
          :mensagem="flagsDeControle.carregandoDados.mensagem"
          />
        </div>
        <!-- /.container-fluid -->
      </section>
      <!-- Main content -->
      <section class="content">
        <div class="row justify-content-center">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex align-items-stretch" v-for="plano of planos"  :key="plano.id">
            <Plano :plano="plano" :key="plano.id">
              <template #acoes>
                <button :class="plano.contratado ? 'botoes btn btn-secondary mt-2  btn-lg btn-block' : 'botoes btn botao mt-4  btn-lg btn-block'" :disabled="pedidoCancelamento || !podeAlterarPlano || plano.contratado" @click="enviarParaCarrinho(plano)">{{ plano.contratado ? 'Atual' : 'Alterar'  }}</button>
              </template>
            </Plano>
          </div>
        </div>
        <duvidas-frequentes></duvidas-frequentes>
      </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import AletrarPlanoContrato from './js/alterar-plano-contrato'
export default AletrarPlanoContrato
</script>
